import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Nav, NavLogo, NavTabs, SkipLink, useMediaQuery } from 'bonfire-kindling';
import { AppContext } from 'contexts';
import { useFeatureFlags } from 'helpers/hooks';
import VendorsLogo from 'assets/BF-VendorsLogo.png';
import BonfireFlamesLogo from 'assets/BonfireFlames.png';
import NavBarRightContent from './NavBarRightContent';

//variant should be one of 'primary', 'hideLinks', or 'preview'
const NavBar = ({ variant = 'primary' }) => {
  const { isSubscribed, isOnboarded, isConfirmed } = useContext(AppContext);
  const { isFlagEnabled } = useFeatureFlags();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isTabletOrDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

  const showSubscribedTabs = variant !== 'hideLinks' && isSubscribed && isOnboarded && isConfirmed;
  const subscribedTabs = useMemo(
    () =>
      showSubscribedTabs
        ? [
            isFlagEnabled('FF_16_RELEASE_TOGGLE_PV_VENDOR_DASHBOARD') && {
              to: '/dashboard',
              component: RouterLink,
              label: t('nav.dashboard'),
              tabIndex: 0,
            },
            {
              to: '/opportunities',
              component: RouterLink,
              label: t('nav.opportunities'),
              tabIndex: 0,
            },
            {
              to: '/settings',
              component: RouterLink,
              label: t('nav.settings'),
              tabIndex: 0,
            },
          ]
        : [],
    [showSubscribedTabs, t, isFlagEnabled]
  );
  const activeSubscribedTab = useMemo(() => {
    const activeTabIdx = subscribedTabs.findIndex(tab =>
      RegExp(`^(${tab.to})(/.*)?`).test(pathname)
    );
    return activeTabIdx > -1 ? activeTabIdx : false;
  }, [pathname, subscribedTabs]);

  return (
    <Nav sx={{ position: 'fixed', zIndex: theme => theme.zIndex.drawer + 1 }}>
      <SkipLink href="#main-content">{t('nav.skip_to_main_content')}</SkipLink>
      <NavLogo
        src={isMobile ? BonfireFlamesLogo : VendorsLogo}
        alt="Bonfire"
        imgProps={{ style: { objectFit: 'cover', width: isMobile && '2.5rem' } }}
      />
      {isTabletOrDesktop && <NavTabs tabs={subscribedTabs} value={activeSubscribedTab} />}

      <Box flexGrow={1} />

      <NavBarRightContent variant={variant} showSubscribedTabs={showSubscribedTabs} />
    </Nav>
  );
};

export default NavBar;
